module.exports = __webpack_public_path__ + "static/media/crown.684af6ea.png";